import React, { Component } from 'react'
import { connect } from 'react-redux'
import { addNewCategory } from '../actions/index'
import Header from './Header'
import Footer from './Footer'


class NewCategory extends Component {

  state = {
    categoryInput: "",
    categorySaved: false
  }

  categoryInput = (event) => {
    this.setState({categoryInput: event.target.value})
  }

  categorySubmit = (event) => { 
    


    // update store and server with new post
    this.props.addCategory(this.state.categoryInput)

    this.setState({categorySaved: true})

    event.preventDefault()
  }


  render() {

    return (
      <div>
          <Header />

          <div style={{textAlign: 'center'}}>
          <p style={{textAlign: 'center'}}>Create a new category.</p>
          <form onSubmit={this.categorySubmit}>
              <label>
                New category<br/>
                <input className="new-title" placeholder="Category" type="text" value={this.state.categoryInput} onChange={this.categoryInput}></input>
              </label><br/>
              
              <input type="submit" className="purple-button" value="Submit" />
          </form>
          </div>

          { (this.state.categorySaved === true)
          ?
            <div>
            <p style={{textAlign: 'center'}}>Your category has been saved</p>
            </div>
          : <p></p>
          }
      
        <Footer />




        

      </div>



    )
  }

}

const mapStateToProps = (state) => {
  
  return {
      categories: state.categories  
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addCategory: (category) => dispatch(addNewCategory(category))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewCategory);


// WEBPACK FOOTER //
// ./src/components/NewCategory.js